import HTTP from "../HTTP";
import Jsona from "jsona";
import paramsHelpers from "@/API/helpers/params";

const dataFormatter = new Jsona();

export default {
  async sendEmailVerification(accountID) {
    try {
      let data = {
        data: {
          id: accountID,
          type: "accounts"
        }
      };

      await HTTP.normal.post("/management/email-verification/send", data);
    } catch (e) {
      throw e;
    }
  },

  async verifyEmail(accountID) {
    try {
      let data = {
        data: {
          id: accountID,
          type: "accounts"
        }
      };

      await HTTP.normal.post("/management/email-verification/verify", data);
    } catch (e) {
      throw e;
    }
  },

  async update(account) {
    try {
      let data = {
        data: {
          id: account.id,
          type: "accounts",
          attributes: {
            first_name: account.first_name,
            last_name: account.last_name,
            occupation: account.occupation,
            language: account.language,
            time_zone: account.time_zone
          }
        }
      };

      await HTTP.normal.patch(`/accounts/${account.id}`, data);
    } catch (e) {
      throw e;
    }
  },

  async searchByName(textSearch, includes = [], filters = []) {
    filters = [...filters, { name: "text_search", value: textSearch }];

    let params = paramsHelpers.buildParams({ includes, filters });
    let url = `accounts${params}`;

    try {
      let res = await HTTP.normal.get(url);
      return dataFormatter.deserialize(res.data);
    } catch (error) {
      throw error;
    }
  },

  async changeStatus(accountID, action) {
    try {
      await HTTP.normal.post(`/management/accounts/${accountID}/${action}`);
    } catch (e) {
      throw e;
    }
  }
};



// WEBPACK FOOTER //
// ./src/API/modules/account.js